import { xhr } from '@/xhr/endpoints';

//
// state
const state = {
  sessionId: '',
};

//
// getters
const getters = {
  getSessionId: state => state.sessionId,
};

//
// mutations
const mutations = {
  setSessionId(state, sessionId) {
    state.sessionId = sessionId;
  },
};

//
// actions
const actions = {
  createSession: async ({ commit }) => {
    try {
      let res = await xhr.createSession();
      commit('setSessionId', res._id);
    } catch (err) {
      commit('setSessionId', '');
    }
  },

  // addSessionLog: async ({state}, data) => {
  //   try {
  //     data = {
  //       time: new Date().toLocaleString(),
  //       user_id: state.userData._id,
  //       document_id: state.documentData._id,
  //       actions: state.debateNextState?.actions || '',
  //       current_round: state.debateNextState?.current_round || '',
  //       current_status: state.debateNextState?.current_status || '',
  //       currentTeam: state.currentTeam || '',
  //       ...data,
  //     };
  //     await xhr.addSessionLog(
  //       state.sessionId,
  //       data,
  //     );
  //     return true
  //   } catch (err) {
  //     return false
  //   }
  // }
};

//
// exports
export default {
  // namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
